import { Component } from "react";

import { Button } from "@bokio/designsystem/components/Button";
import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import GeneralLangFactory from "@bokio/lang/GeneralLangFactory";

import { AnimatedFeedbackBlock, FeedbackAnimation } from "../AnimatedFeedbackBlock/AnimatedFeedbackBlock";

import type { ReactNode } from "react";

import * as styles from "./helpStyle.scss";

interface HelpMessageStatusProps {
	confirmationMessage: string | ReactNode;
	isLoading: boolean;
	subscribeToPrio?: () => void;
	onClose?: () => void;
}

class HelpMessageStatus extends Component<HelpMessageStatusProps> {
	render() {
		const lang = GeneralLangFactory();
		return (
			<div className={styles.helpConfirmation}>
				{!this.props.isLoading && (
					<div className={styles.helpConfirmationInner}>
						<AnimatedFeedbackBlock
							animation={FeedbackAnimation.Checkmark}
							title={lang.HelpConfirmationHeading}
							buttons={[
								<Button key="done" margin={["top"]} appearance="secondary" onClick={() => this.props.onClose?.()}>
									{lang.Done}
								</Button>,
							]}
						>
							<Paragraph>{this.props.confirmationMessage}</Paragraph>
						</AnimatedFeedbackBlock>
					</div>
				)}
			</div>
		);
	}
}

export default HelpMessageStatus;
